import "../../../css/Buttons/PrimaryButton.css";

const PrimaryButton = ({
  label,
  onClick,
  isDisabled = false,
  isLoading = false,
  isActive = false,
}) => {
  return (
    <button
      className={`AML-Primary-Button-Container
        ${isDisabled ? "disabled" : ""}
        ${isLoading ? "loading" : ""}
        ${isActive ? "active" : ""}`}
      onClick={onClick}
      disabled={isDisabled || isLoading}
    >
      <div className="AML-Text-Body">{label}</div>
    </button>
  );
};

export default PrimaryButton;
